const NoChartData = ({ msg }) => {
  return (
    <div>
      <div className="text-center" style={{ padding: "10%", fontSize: "18px" }}>
        <i
          className="pi pi-chart-bar mb-3"
          style={{ fontSize: "100px", color: "#eeeeee" }}
        ></i>
        <p>{msg}</p>
      </div>
    </div>
  );
};

export default NoChartData;
